<template>
  <div id="app">
    <NavBar />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import api from "@/utils/api";
import store from "@/store";
import { ElMessage } from "element-plus";

export default {
  name: 'App',
  components: {
    NavBar
  },
  mounted() {
    this.validateSession();
  },
  methods: {
    async validateSession() {
      const token = store.state.token || localStorage.getItem('token');
      if (token) {
        try {
          // Call an endpoint that requires authentication to validate token
          await api.get('/api/user/profile');
        } catch (err) {
          if (err.response && err.response.status === 401) {
            // Show message to user about being logged out
            ElMessage.warning('您的账号已在其他设备登录，请重新登录');
          }
          // The api interceptor will handle clearing auth and redirecting
        }
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>